import React, { useEffect, useState } from 'react'

const HomeHtmlPage: React.FC = () => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  useEffect(() => {
    const listener = (event: MessageEvent): void => {
      if (event.data?.type === 'chat-open') {
        setIsChatOpen(event.data.isOpen)
      }
    }

    window.addEventListener('message', listener)
    return () => window.removeEventListener('message', listener)
  }, [])

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh', backgroundColor: 'transparent' }}>
      <iframe
        src="/html/test.html"
        width="100%"
        height="100%"
        style={{ border: 'none', backgroundColor: 'white' }}
        title="Snapshot Page"
      />

      <iframe
        src="/chat-frame"
        title="Chat iframe"
        style={{
          border: 'none',
          position: 'fixed',
          bottom: 0,
          right: 0,
          width: '120px',
          height: '120px',
          zIndex: 9999,
        }}
        className={`chat-frame ${isChatOpen ? 'open' : ''}`}
      />
    </div>
  )
}

export default HomeHtmlPage
